<template>
  <base-content-block id="courseClosing">
    <template #title>{{ $t('src/pages/courseclosing.694') }}</template>
    <template #content>
      <section class="ml-2">
        <h5 class="mb-3">{{ $t('src/pages/courseclosing.8901', { '1': courseId }) }}</h5>
        <course-pin-code v-if="isAppBound" :course-id="courseId">
          <template #underPin>
            <base-form-group class="mt-2">
              <base-checkbox name="checkbox-no-pin" v-model="checkedNoPin" class="text-muted">{{
                $t('src/pages/courseclosing.2313')
              }}</base-checkbox>
            </base-form-group>
          </template>
        </course-pin-code>
        <h4 class="mb-2 mt-2" v-else-if="!checkedNoPin">{{ $t('src/pages/courseclosing.7212') }}</h4>
      </section>
      <section class="ml-2 mt-4 form-limited-width">
        <base-form-group
          v-if="checkedNoPin"
          :label="$t('src/pages/courseclosing.1340')"
          :is-invalid="$v.errorReason.$error"
          :errors="{
            required: !$v.errorReason.required
          }"
        >
          <base-dropdown-select
            :options="reasons"
            v-model="errorReason"
            class="form-control"
          ></base-dropdown-select>
        </base-form-group>
      </section>
      <section v-if="deviceId" class="ml-2 mt-4 form-limited-width">
        <h6 class="mb-3">{{ $t('src/pages/courseclosing.7684') }}</h6>
        <base-form-group>
          <input
            type="radio"
            value="broken"
            v-model="checkedDevice"
            @click="uncheck('broken')"
            class="mx-1"
          />
          <label>{{ $t('src/pages/courseclosing.3935') }}</label>
          <input
            type="radio"
            value="lost"
            v-model="checkedDevice"
            @click="uncheck('lost')"
            class="mx-1 ml-3"
          />
          <label>{{ $t('src/pages/courseclosing.2396') }}</label>
        </base-form-group>
      </section>
      <button type="button" @click="saveErrors" class="btn btn-danger" :disabled="!isCanFinish">
        {{ $t('button.complete') }}
      </button>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { status, deviceStatus } from '@/main.config.js'
import { requiredIf } from 'vuelidate/lib/validators'
import { contentTpl } from '@/mixins/content-tpl.js'
import { subscribeUnlinkMobile } from '@/mixins/subscribe-unlink-mobile.js'
import { DATE_FORMAT } from '@/main.config'

export default {
  name: 'CoursesClosing',
  components: {
    CoursePinCode: () => import('@/components/CoursePinCode.vue'),
    BaseCheckbox: () => import('@/base/BaseCheckbox.vue'),
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue'),
    BaseFormGroup: () => import('@/base/BaseFormGroup.vue')
  },
  mixins: [contentTpl, subscribeUnlinkMobile],
  data: function() {
    return {
      deviceId: null,
      courseStatus: null,
      isAppBound: undefined,
      courseId: null,
      checkedNoPin: false,
      reasons: {
        lost: this.$t('src/pages/courseclosing.lost'),
        broken: this.$t('src/pages/courseclosing.broken'),
        app_not_work: this.$t('src/pages/courseclosing.appNotWork')
      },
      errorReason: null,
      checkedDevice: false
    }
  },
  validations: {
    errorReason: {
      required: requiredIf(function() {
        return !!this.checkedNoPin
      })
    }
  },
  computed: {
    isCanFinish() {
      return (!this.isAppBound || this.checkedNoPin) && !this.$v.$invalid
    }
  },
  mounted() {
    this.canSubscribe = true
    this.courseId = parseInt(this.$route.params.id)
    this.checkIsAppBound()
  },
  methods: {
    checkIsAppBound() {
      http
        .get('/courses/' + this.courseId)
        .then(response => {
          this.deviceId = response.data.device_id
          this.courseStatus = response.data.status
          if (response.data.app_api_key) {
            this.isAppBound = true
          }
        })
        .catch(error => console.log(error))
    },
    setCourseClosed() {
      http
        .patch('/courses/' + this.courseId, {
          status: this.checkedNoPin ? status.closedWrong : status.closed,
          app_api_key: null,
          qr_code_link_token: null,
          close_date: this.moment().format(DATE_FORMAT.serverFull),
          unlink_error:
            this.checkedNoPin && this.reasons[this.errorReason] ? this.reasons[this.errorReason] : null
        })
        .then(() => {
          this.setDeviceStatus()
          this.goToEditCourse()
        })
        .catch(error => {
          console.log(error)
        })
    },
    setDeviceStatus() {
      if (!this.deviceId) {
        return
      }
      http
        .patch('/devices/' + this.deviceId, {
          status: this.checkedDevice
            ? this.checkedDevice == 'lost'
              ? deviceStatus.lost
              : deviceStatus.broken
            : deviceStatus.work
        })
        .catch(error => {
          console.log(error)
        })
    },
    saveErrors() {
      this.setCourseClosed()
    },
    goToEditCourse() {
      this.$router.push({
        name: 'course-edit',
        id: this.courseId
      })
    },
    uncheck(value) {
      if (value === this.checkedDevice) {
        this.checkedDevice = false
      }
    },
    setCourseBindingInfo() {
      this.isAppBound = false
      this.canSubscribe = false
    }
  }
}
</script>
